import { useEffect, useMemo, useState } from 'react';
import { Content, Title, InputFormTable } from 'components';
import { Select } from 'antd';
import { useGetTags } from 'hooks/TagHooks';
import styles from '../styles';

const ProductHashtagInformation = ({ data }) => {
  const response = useGetTags();
  const tags = useMemo(() => {
    if (data) {
      return data.tag.map((tag) => tag.tag_id);
    }

    return [];
  }, [data]);
  const [tagList, setTagList] = useState([]);

  const getTagSelectOptions = () => {
    return (
      tagList
        // .filter((item) => item.is_show === 'Y')
        .map((item) => ({ label: item.tag_name, value: item.tag_id }))
    );
  };

  const form = [
    {
      label: '태그',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%' }}
                options={getTagSelectOptions()}
                value={tags}
                open={false}
              />
            </>
          ),
          fullscreen: true,
        },
      ],
    },
  ];

  useEffect(() => {
    if (response && response.data) {
      const { data } = response.data;
      setTagList(data);
    }
  }, [response]);

  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 25 }}
      className="boxShadow"
    >
      <Title style={{ ...styles.subTitle }}>태그 설정</Title>
      <InputFormTable labelWidth={160} form={form} />
    </Content>
  );
};

export default ProductHashtagInformation;
